import "./App.css";
import { createBrowserRouter, RouterProvider, Route } from "react-router-dom";
import GlobalStyles from "./GlobalStyles";
import HomePage from "./pages/Homepage";
import LoginPage from "./pages/LoginPage";
import ProductsPage from "./pages/ProductPage";
import Dashboard from "./pages/Dashboard/dashboard";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import CategoriesPage from "./pages/CategoryPage";
import NavbarElement from "./components/Navbar/NavbarElement";
import Footer from "./components/Footer/footer";
import SigupPage from "./pages/SignupPage/SignupPage";

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <SigupPage />,
  },
  {
    path: "/product/:id",
    element: <ProductsPage />,
  },
  {
    path: "/category/:id",
    element: <CategoriesPage />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
]);

function App() {
  return (
    <>
      <GlobalStyles />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}></RouterProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
